module.exports = __webpack_public_path__ + "img/49b7e06.jpg";